import { useContext } from 'react';

// asp provider
import AspContext, { AspContextType } from 'contexts/AspContext';

// ==============================|| ASP HOOKS ||============================== //

const useAsp = (): AspContextType => {
  const context = useContext(AspContext);

  if (!context) throw new Error('context must be use inside provider');

  return context;
};

export default useAsp;
